/* =================== MINHA CONTA =================== */
jQuery(document).ready(function ($) {
  // Exibe a confirmação ao clicar no botão de remover
  $(".btn-confirm").on("click", function (e) {
    e.preventDefault();
    var idRemove = $(this).data("id");
    $("#id_remove").val(idRemove);
    openModal("modal-confirm");
  });

  // Exibe a confirmação ao clicar no botão de cancelar plano
  $(".btn-cancela").on("click", function (e) {
    e.preventDefault();
    var idCancela = $(this).data("id");
    $("#id_cancela").val(idCancela);
    openModal("modal-cancelar");
  });

  // Curtir
  function curtir(idCurtir, idUserCurtir, origem) {
    $.ajax({
      type: "POST",
      url: url_base + 'acoes/app/usuarios/curtir_post.php',
      data: {
        idPost: idCurtir,
        idUser: idUserCurtir,
        origem: origem
      },
      success: function (resposta) {
        console.log(resposta);
        /* showAlert(
          "Sucesso",
          "Curtido com sucesso.",
          "success"
        ); */
        setTimeout(() => {
          location.reload();
        }, 500);
      }
    });
  }
  $(".act-curtir").on("click", function (e) {
    e.preventDefault();
    var idCurtir = $(this).data("id");
    var idUserCurtir = $(this).data("iduser");
    var origem = $(this).data("origem");
    curtir(idCurtir, idUserCurtir, origem);
  });


  // Descurtir
  function descutir(idUserDescurtir, origem) {
    $.ajax({
      type: "POST",
      url: url_base + 'acoes/app/usuarios/descutir_post.php',
      data: {
        idUser: idUserDescurtir,
        origem: origem
      },
      success: function (resposta) {
        console.log(resposta);
        /* showAlert(
          "Sucesso",
          "Descurtido com sucesso.",
          "success"
        ); */
        setTimeout(() => {
          location.reload();
        }, 500);
      }
    });
  }
  $(".act-descutir").on("click", function (e) {
    e.preventDefault();
    var idUserDescurtir = $(this).data("iduser");
    var origem = $(this).data("origem");
    descutir(idUserDescurtir, origem);
  });


  // Remover post
  function removerPost(idUserRemover, idPostRemover) {
    $.ajax({
      type: "POST",
      url: url_base + 'acoes/app/usuarios/remover_post.php',
      data: {
        idUser: idUserRemover,
        idPost: idPostRemover
      },
      success: function (resposta) {
        console.log(resposta);
        showAlert(
          "Sucesso",
          "Removido com sucesso.",
          "success"
        );
        setTimeout(() => {
          location.reload();
        }, 1500);
      }
    });
  }
  $(".act-removerpost").on("click", function (e) {
    e.preventDefault();
    var idUserRemover = $(this).data("iduser");
    var idPostRemover = $(this).data("idpost");
    var confirmText = "Tem certeza de que deseja excluir o post?";
    if (confirm(confirmText)) {
      removerPost(idUserRemover, idPostRemover);
    }
  });

  // Remover espaco
  function removerEspaco(idUserRemover, idEspacoRemover) {
    $.ajax({
      type: "POST",
      url: url_base + 'acoes/app/usuarios/remover_espaco.php',
      data: {
        idUser: idUserRemover,
        idEspaco: idEspacoRemover
      },
      success: function (resposta) {
        console.log(resposta);
        showAlert(
          "Sucesso",
          "Removido com sucesso.",
          "success"
        );
        setTimeout(() => {
          location.reload();
        }, 1500);
      }
    });
  }
  $(".act-removespaco").on("click", function (e) {
    e.preventDefault();
    var idUserRemover = $(this).data("iduser");
    var idEspacoRemover = $(this).data("idespaco");
    var confirmText = "Tem certeza de que deseja excluir a pasta?";
    if (confirm(confirmText)) {
      removerEspaco(idUserRemover, idEspacoRemover);
    }
  });



  // Exibe/Oculta os campos da forma de pagamento escolhida
  $('input[name="forma-pagamento"]').on("change", function () {
    $(".forma-pag-content").slideUp();
    $(".forma-pag-content .campo").prop("disabled", true);
    $(".forma-pag-content .campo").prop("required", false);

    $('.forma-pag-content[data-forma="' + $(this).val() + '"]').slideDown();
    $('.forma-pag-content[data-forma="' + $(this).val() + '"] .campo').prop(
      "disabled",
      false
    );
    $('.forma-pag-content[data-forma="' + $(this).val() + '"] .campo').prop(
      "required",
      true
    );
  });


  // Processa o formulário
  $('#form-espaco').on("submit", function (ev) {
    ev.preventDefault();

    var enviando_formulario = false;
    const obj = this;
    const dados = new FormData(obj);

    if (!enviando_formulario) {
      $.ajax({
        url: $('#form-espaco').attr("action"),
        type: $('#form-espaco').attr("method"),
        data: dados,
        processData: false,
        cache: false,
        contentType: false,
        beforeSend: function () {
          //showLoading();
          enviando_formulario = true;
          $('#form-espaco .btn-act').attr("disabled", true);
          $('#form-espaco .btn-act').text("Aguarde...");
        },
        success: function (resp) {
          console.log(resp);
          resp = JSON.parse(resp);
          if (resp.status == "success") {
            closeModal("modal-espaco");
            showAlert("Sucesso", resp.msg, "success");
          } else {
            closeModal("modal-espaco");
            showAlert("Erro", resp.msg, "error");
          }
          setTimeout(() => {
            location.reload();
          }, 2000);
        },
        error: function (xhr, type, exception) {
          closeModal("modal-espaco");
          showAlert(
            "Erro",
            "Não foi possível realizar esta operação.",
            "error"
          );
          console.log("ajax error response type " + type);
          setTimeout(() => {
            location.reload();
          }, 2000);
        },
      });
    }
  });

  // Processa o formulário
  $('#form-publicar').on("submit", function (ev) {
    ev.preventDefault();

    var enviando_formulario = false;
    const obj = this;
    const dados = new FormData(obj);

    if (!enviando_formulario) {
      $.ajax({
        url: $('#form-publicar').attr("action"),
        type: $('#form-publicar').attr("method"),
        data: dados,
        processData: false,
        cache: false,
        contentType: false,
        beforeSend: function () {
          //showLoading();
          enviando_formulario = true;
          $('#form-publicar .btn-act').attr("disabled", true);
          $('#form-publicar .btn-act').text("Aguarde...");
        },
        success: function (resp) {
          console.log(resp);
          resp = JSON.parse(resp);
          if (resp.status == "success") {
            closeModal("modal-publicar");
            showAlert("Sucesso", resp.msg, "success");
          } else {
            closeModal("modal-publicar");
            showAlert("Erro", resp.msg, "error");
          }
          setTimeout(() => {
            location.reload();
          }, 2000);
        },
        error: function (xhr, type, exception) {
          closeModal("modal-publicar");
          showAlert(
            "Erro",
            "Não foi possível realizar esta operação.",
            "error"
          );
          console.log("ajax error response type " + type);
          setTimeout(() => {
            location.reload();
          }, 2000);
        },
      });
    }
  });

  // Processa o formulário
  $('#form-comentario').on("submit", function (ev) {
    ev.preventDefault();

    var enviando_formulario = false;
    const obj = this;
    const dados = new FormData(obj);

    if (!enviando_formulario) {
      $.ajax({
        url: $('#form-comentario').attr("action"),
        type: $('#form-comentario').attr("method"),
        data: dados,
        processData: false,
        cache: false,
        contentType: false,
        beforeSend: function () {
          //showLoading();
          enviando_formulario = true;
          $('#form-comentario .btn-act').attr("disabled", true);
          $('#form-comentario .btn-act').text("Aguarde...");
        },
        success: function (resp) {
          console.log(resp);
          resp = JSON.parse(resp);
          if (resp.status == "success") {
            closeModal("modal-comentario");
            //showAlert("Sucesso", resp.msg, "success");
          } else {
            closeModal("modal-comentario");
            showAlert("Erro", resp.msg, "error");
          }
          setTimeout(() => {
            location.reload();
          }, 1000);
        },
        error: function (xhr, type, exception) {
          closeModal("modal-publicar");
          showAlert(
            "Erro",
            "Não foi possível realizar esta operação.",
            "error"
          );
          console.log("ajax error response type " + type);
          setTimeout(() => {
            location.reload();
          }, 2000);
        },
      });
    }
  });

});
